// frontend/src/logger.js

import log from 'loglevel';

// Set log level based on environment
if (process.env.NODE_ENV === 'production') {
  log.setLevel('warn'); // Only log warnings and errors in production
} else {
  log.setLevel('debug'); // Log everything in development
}

export default log;
